import { IAEntrenamientoProvider } from "./IAEntrenamientoContext";

export const AllIAProvider = (props) => (
    <IAEntrenamientoProvider>
        {props.children}
    </IAEntrenamientoProvider>
);